@if (toastService.toasts.length > 0) {
  <div class="toast-container position-fixed top-0 end-0 p-5">
    @for (toast of toastService.toasts; track $index) {
      <ngb-toast [class]="toast.classname" [autohide]="true" [delay]="toast.delay" (hidden)="toastService.remove(toast)">
        <div class="d-flex flex-row align-items-center justify-content-around">
          @if (toast.classname === 'bg-success') {
            <img src="assets/icons/toast/checkmark.svg">
            <div class="d-flex flex-column">
              <h2>{{ "toast-success" | translate }}</h2>
              @if (isTemplate(toast)) {
                <ng-container *ngTemplateOutlet="toast.textOrTpl"></ng-container>
              } @else {
                {{ toast.textOrTpl }}
              }
            </div>
          } @else if (toast.classname === 'bg-danger') {
            <img src="assets/icons/toast/xmark.svg">
            <div class="d-flex flex-column">
              <h2>{{ "toast-error" | translate }}</h2>
              @if (isTemplate(toast)) {
                <ng-container *ngTemplateOutlet="toast.textOrTpl"></ng-container>
              } @else {
                {{ toast.textOrTpl }}
              }
            </div>
          }
        </div>
      </ngb-toast>
    }
  </div>
}